var _excluded = ["id", "label", "hideLabel", "hasError", "helpText", "fieldMessage", "size", "optionalText", "resize", "className", "textAreaClassName"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { string, bool, oneOf } from 'prop-types';
import classNames from 'classnames';
import uuid from 'uuid';
import FormGroup from '../FormGroup/FormGroup';
import Label from '../Label/Label';
import HelpText from '../HelpText/HelpText';
import FieldMessage from '../FieldMessage/FieldMessage';
import TextArea from '../TextArea/TextArea';
var propTypes = {
  /** Label text */
  label: string.isRequired,

  /** The component will generate an id for you.<br>
   * If you need to create your own, pass it in as a prop */
  id: string,

  /** Visually hide the label */
  hideLabel: bool,

  /** Visual presentation of an error in the input */
  hasError: bool,

  /** Help text below the input form field */
  helpText: string,

  /** Usually used for validation */
  fieldMessage: string,

  /** The text area can have different sizes. Choose between:  */
  size: oneOf(['small', 'medium', 'large']),

  /** Text describing the input as optional */
  optionalText: string,

  /** The direction the textarea can be resized  */
  resize: oneOf(['vertical', 'horizontal', 'both', 'none']),

  /** Add your own custom class names to the component */
  className: string,

  /** Add your own custom class names directly to the `textarea` inside the group*/
  textAreaClassName: string
};
var defaultProps = {
  resize: 'vertical',
  size: 'medium'
};
/** The text area group is a packaged component that includes a TextArea, a Label, a HelpText and a FieldMessage. Everything is wrapped in a FormGroup.
 * @visibleName Text Area Group
 * */

var TextAreaGroup = function TextAreaGroup(_ref) {
  var id = _ref.id,
      label = _ref.label,
      hideLabel = _ref.hideLabel,
      hasError = _ref.hasError,
      helpText = _ref.helpText,
      fieldMessage = _ref.fieldMessage,
      size = _ref.size,
      optionalText = _ref.optionalText,
      resize = _ref.resize,
      className = _ref.className,
      textAreaClassName = _ref.textAreaClassName,
      rest = _objectWithoutProperties(_ref, _excluded);

  var helpTextId = "rds-form-text-".concat(uuid.v4());
  var fieldMessageId = "rds-fieldmessage-".concat(uuid.v4());
  var textAreaId = id || "rds-input-".concat(uuid.v4());
  var componentClassNames = classNames({
    'rds-form-group--danger': hasError
  }, className);
  /* Create the aria-describedby text based on what elements are present*/

  var ariaDescribedBy;

  if (fieldMessage && helpText) {
    ariaDescribedBy = "".concat(helpTextId, " ").concat(fieldMessageId);
  } else if (helpText) {
    ariaDescribedBy = helpTextId;
  } else if (fieldMessage) {
    ariaDescribedBy = fieldMessageId;
  } else {
    ariaDescribedBy = null;
  }

  return /*#__PURE__*/React.createElement(FormGroup, {
    className: componentClassNames
  }, /*#__PURE__*/React.createElement(Label, {
    htmlFor: textAreaId,
    labelText: label,
    hideLabel: hideLabel,
    optionalText: optionalText
  }), /*#__PURE__*/React.createElement(TextArea, _extends({
    size: size,
    hasError: hasError,
    resize: resize,
    id: textAreaId,
    className: textAreaClassName
  }, ariaDescribedBy && {
    'aria-describedby': ariaDescribedBy
  }, rest)), fieldMessage && /*#__PURE__*/React.createElement(FieldMessage, {
    text: fieldMessage,
    skin: hasError ? 'danger' : null,
    id: fieldMessageId
  }), helpText && /*#__PURE__*/React.createElement(HelpText, {
    text: helpText,
    id: helpTextId
  }));
};

TextAreaGroup.propTypes = propTypes;
TextAreaGroup.defaultProps = defaultProps;
export default TextAreaGroup;